import type { ComponentLineProps } from "../../FirstPaymentPreview/types";
import { RawLines } from "../RawLines";

export const DiscountLine = ({ preview, options }: ComponentLineProps) => {
  if (!preview.future_payments || preview.future_payments.discount >= 0) {
    return null;
  }

  return <RawLines.DiscountLine preview={preview} options={options} />;
};
